// extracted by mini-css-extract-plugin
export default {"grocery-form":"GroceryForm_grocery-form__gngF-","form-control":"GroceryForm_form-control__3yWbE","form-action":"GroceryForm_form-action__iFBzS"};